import { useTranslation } from "hooks/useTranslation";
import { useEffect, useState, Fragment } from "react";
import TextButton from "./TextButton";
import { DisLikeIcon } from "Assets/icons/dislike.icon";
import { Dialog } from "@mui/material";
import { ReportForm } from "Components";
import { SEARCH_PARAM_VALUES, SEARCH_PARAMS } from "constants/routes";
import { getSearchParam } from "utils/searchParamsUtils";

const ComplaintButton = ({
  type,
  title,
  reference_name,
  onComplete,
  textComponent: TextComponent,
  textColor,
}: {
  type?: string;
  title?: string;
  reference_name?: string;
  onComplete?: () => void;
  textComponent?: React.ComponentType<{ children: React.ReactNode; color?: string }>;
  textColor?: string;
}) => {
  const t = useTranslation();
  const popupParam = getSearchParam(SEARCH_PARAMS.popup);

  const [showReport, setShowReport] = useState(false);

  const onCloseReport = () => setShowReport(false);

  useEffect(() => {
    if (popupParam === SEARCH_PARAM_VALUES.popupComplaint) {
      setShowReport(true);
    }
  }, [popupParam]);

  const buttonText = t("file_a_complaint");

  return (
    <Fragment>
      <TextButton
        startIcon={<DisLikeIcon />}
        onClick={() => setShowReport(true)}
      >
        {TextComponent ? (
          <TextComponent color={textColor}>{buttonText}</TextComponent>
        ) : (
          buttonText
        )}
      </TextButton>

      <Dialog open={showReport} onClose={onCloseReport}>
        <ReportForm
          onClose={onCloseReport}
          {...{ type, title, reference_name, onComplete }}
        />
      </Dialog>
    </Fragment>
  );
};

export default ComplaintButton;
